<template>
  <div
    id="con2"
    class="conBox"
    :class="menuBtn"
  >
    <!-- 주문내역 -->
    <div class="orderList_wrap">
      <template v-if="isData">
        <history-list
          v-for="history in orderHistorys"
          :key="history.order_key"
          :order-history="history"
          :req-no="reqNo"
          :purchase-type="purchaseType"
          @on-cancel-order="onCancelOrder"
          @delivery-change="onDeliveryList"
          @group-delivery-change="onCheckGroupDelivery"
        />
      </template>
      <!-- 주문내역 없을때 2020-11-23 -->
      <div
        v-if="!isData"
        class="no_result"
      >
        <p>결제 완료된 내역이 없습니다.</p>
      </div>
    </div>
    <modal-delivery-list
      ref="refModal"
      @set-delivery-location="changeDeliveryLocation"
    />
    <modal-change-group-delivery ref="refGroupModal" :order-key="orderKey" :groupList="groupOrderInfo" @delivery-change="onDeliveryList"/>
    <modal-alert ref="refAlert" />
  </div>
</template>

<script>
import ModalDeliveryList from '@/components/modal-popups/ModalDeliveryList.vue';
import ModalChangeGroupDelivery from '@/components/modal-popups/ModalChangeGroupDelivery.vue';
import orderApi from '@/apis/order';
import ModalAlert from '@/components/global/ModalAlert';
import HistoryList from './history-part/HistoryList.vue';

export default {
  name: 'OrderHistory',
  components: {
    HistoryList,
    ModalDeliveryList,
    ModalAlert,
    ModalChangeGroupDelivery
  },
  props: {
    menuBtn: {
      type: String,
      default: '',
    },
    orderHistorys: {
      type: Array,
      default: () => [],
    },
    reqNo: {
      type: Number,
      default: 0,
    },
    purchaseType: {
      type: String,
      default: '',
    },
    groupOrderInfo: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      orderKey: '',
    };
  },
  computed: {
    isData() {
      if (this.orderHistorys.length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onCancelOrder() {
      this.$emit('on-cancel-order');
    },
    onDeliveryList(e) {
      this.orderKey = e;
      this.$refs.refModal.open();
    },
    onCheckGroupDelivery(orderKey) {
      this.orderKey = orderKey;
      this.$refs.refGroupModal.open();
    },
    async changeDeliveryLocation(e) {
      e.order_key = this.orderKey;
      const r = await orderApi.changeDeliveryDestination(e);
      console.log(r);
      if (r.error) {
        console.error(r.error);
        return;
      }
      this.$emit('delivery-change');
      await this.$refs.refAlert.openWithMessage('배송지가 변경 되었습니다.');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/mypacks/detail/partial/OrderHistory.vue